export enum Direction {
  Forward = 1,
  Backward = -1,
}



// WEBPACK FOOTER //
// ../src/types/direction.ts